module.exports = __webpack_public_path__ + "img/sourceChannel.c12f5b3a.svg";